import styled from 'styled-components';

export const Wrapper = styled.div<{ $fromActivity: boolean }>`
  position: relative;
  width: 95%;
  max-width: 840px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 16px;
  border-radius: 8px;
  margin-bottom: 8px;
  box-shadow: 0px 3px 6px -4px rgba(0, 0, 0, 0.12), 0px 6px 16px 0px rgba(0, 0, 0, 0.08),
    0px 9px 28px 8px rgba(0, 0, 0, 0.05);
  position: absolute;
  top: ${({ $fromActivity }) => ($fromActivity ? '-100px' : '-20px')};
  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    top: ${({ $fromActivity }) => ($fromActivity ? '-100px' : '-20px')};
  }
`;

export const ProgressUp = styled.div`
  margin-top: -165px;
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  filter: drop-shadow(0px -2px 8px rgba(0, 0, 0, 0.15));

  @media (min-width: ${({ theme }) => theme.mediaQueries.xs}) {
    margin-top: -100px;
  }
`;

export const ResultsDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 8px;
  width: 100%;
`;
export const ResultsText = styled.span`
  color: ${({ theme }) => theme.colors.black9};
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.2px;
`;
export const SoftText = styled.span`
  color: ${({ theme }) => theme.colors.black7};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;
export const TitlesWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 20px;
  width: 100%;
`;
export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  width: 100%;
  padding-bottom: 24px;
`;

export const StatsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;

export const ResponsesTypesWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 12px;
`;

export const FooterWrapper = styled.div`
  padding-top: 8px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 12px;
  width: 100%;
`;
